import React from 'react';
import { FloatButton } from 'antd';

export const SupportButton = React.memo(props => {
    const { href } = props;

    return (
        <FloatButton
            icon={<img src="/assets/img/icons/support-button.svg" alt="support button icon" style={{ width: "22px", alignSelf: "center" }} />}
            className="support-button"
            href={href}
            target="_blank"
        />
    );
});
